import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAxiosInstance } from "../../../services/Interceptor";
import { CreateOffer } from "../../../services/AthleteService";
import LoadingSpinner from "../../../components/LoadingSpinner";

const OfferForm = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const apiInstance = useAxiosInstance();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await CreateOffer(apiInstance, data);
      toast.success("Offer created successfully!", { position: "top-center" });
    } catch (error) {
      toast.error("Failed to created Offer!", { position: "top-center" });
    } finally {
      setLoading(false);
      reset();
    }
    reset();
  };

  return (
    <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-bold mb-4">NEW OFFER</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              className="block text-sm font-semibold mb-1"
              htmlFor="school"
            >
              SCHOOL
            </label>
            <input
              id="school"
              type="text"
              {...register("school", { required: "School is required" })}
              placeholder="School..."
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>

          <div className="mb-4">
            <label
              className="block text-sm font-semibold mb-1"
              htmlFor="division"
            >
              DIVISION
            </label>
            <select
              id="division"
              {...register("division", { required: "Division is required" })}
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              <option value="Division 1 (FBS)">Division 1 (FBS)</option>
              <option value="Division 1 (FCS)">Division 1 (FCS)</option>
              <option value="Division 2">Division 2</option>
              <option value="Division 3">Division 3</option>
              <option value="Juco">Juco</option>
              <option value="NAIA">NAIA</option>{" "}
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-1" htmlFor="year">
              YEAR
            </label>
            <input
              id="year"
              type="text"
              {...register("year", { required: "Year is required" })}
              placeholder="Year..."
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div className="form-field mt-4">{loading && <LoadingSpinner />}</div>

          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={() => reset()}
              className="text-gray-600 font-semibold hover:text-gray-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-red-500 text-white py-2 px-6 rounded hover:bg-red-600"
            >
              ADD
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OfferForm;
